"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSecondaryTitle = exports.addTitleStylesheet = void 0;
var addTitleStylesheet = function (playerConfig) {
    var _a, _b, _c, _d, _e, _f, _g;
    var titleStyleSheet = document.getElementById('talpa-title-sheet');
    var logoLeft = document.getElementsByClassName('jw-logo-bottom-left')[0];
    var logoRight = document.getElementsByClassName('jw-logo-bottom-right')[0];
    if ((logoRight === null || logoRight === void 0 ? void 0 : logoRight.offsetWidth) === 0 || (logoLeft === null || logoLeft === void 0 ? void 0 : logoLeft.offsetWidth) === 0) {
        setTimeout(exports.addTitleStylesheet, 200, playerConfig);
        return;
    }
    var titleStyles = "\n     .jw-title.talpa-title-bottom-left,\n     .jw-title.talpa-title-bottom-right {\n        bottom: 10px;\n     }";
    if (((_a = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _a === void 0 ? void 0 : _a.position) === 'bottom-left') {
        titleStyles += "\n     .jwplayer .jw-title.talpa-title-bottom-left {\n       padding-left: ".concat(logoLeft === null || logoLeft === void 0 ? void 0 : logoLeft.offsetWidth, "px;\n       left: 0;\n      }\n     .jw-logo-bottom-left {\n       bottom: 10px;\n      }");
    }
    if (((_b = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _b === void 0 ? void 0 : _b.position) === 'bottom-right') {
        titleStyles += "\n     .jwplayer .jw-title.talpa-title-bottom-right {\n       padding-right: ".concat((logoRight === null || logoRight === void 0 ? void 0 : logoRight.offsetWidth) + 10, "px;\n       right: 0;\n      }\n      .jw-logo.jw-logo-bottom-right {\n       bottom: 10px;\n      }  \n       ");
    }
    if (((_c = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _c === void 0 ? void 0 : _c.position) !== 'top-left') {
        titleStyles += "\n    .jw-title.talpa-title-top-left {\n      padding-left: 20px !important;\n    }\n    .jw-title {\n      padding-top: ".concat(((_d = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _d === void 0 ? void 0 : _d.margin) + 5, "px\n    }");
    }
    if (((_e = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _e === void 0 ? void 0 : _e.position) !== 'top-right') {
        titleStyles += "\n    .jw-title.talpa-title-top-right {\n      padding-right: 20px !important;\n    }";
    }
    if (((_f = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _f === void 0 ? void 0 : _f.position) !== 'bottom-left') {
        titleStyles += "\n    .jw-title.talpa-title-bottom-left {\n      left: 15px;\n    }";
    }
    if (((_g = playerConfig === null || playerConfig === void 0 ? void 0 : playerConfig.logo) === null || _g === void 0 ? void 0 : _g.position) !== 'bottom-right') {
        titleStyles += "\n    .jw-title.talpa-title-bottom-right {\n      right: 15px;\n      padding-right: 0!important;\n    }";
    }
    if (titleStyleSheet) {
        titleStyleSheet.innerHTML = titleStyles;
    }
    else {
        var newSheet = document.createElement('style');
        newSheet.id = 'talpa-title-sheet';
        newSheet.innerHTML = titleStyles;
        document.body.appendChild(newSheet);
    }
};
exports.addTitleStylesheet = addTitleStylesheet;
var generateSecondaryTitle = function (seasonNumber, tvSeasonEpisodeNumber) {
    var secondaryTitle = '';
    if (tvSeasonEpisodeNumber) {
        secondaryTitle += "Aflevering ".concat(tvSeasonEpisodeNumber);
    }
    if (seasonNumber) {
        secondaryTitle += secondaryTitle ? ', ' : '';
        secondaryTitle += "Seizoen ".concat(seasonNumber);
    }
    return secondaryTitle;
};
exports.generateSecondaryTitle = generateSecondaryTitle;
